const MixinErrorsLaravel = {
    install(Vue) {
        Vue.mixin({
            data() {
                return {
                    $errorsResponseFromLaravel: [],
                }
            },
        })
    },
}

export default MixinErrorsLaravel



//////////////////
// WEBPACK FOOTER
// ./~/vue-has-error-laravel/mixins/errorsLaravel.js
// module id = 627
// module chunks = 0